import { useLocation } from 'react-router';

const useAgentMenuItem = () => {
  const location = useLocation();
  return location.pathname.split('/')[2];
};

export default useAgentMenuItem;
